<template>
  <div
    :class="$style.root"
    v-html="html"
  />
</template>

<script setup>
const props = defineProps({
  string: {
    type: String,
    required: true
  },
  forceTargetBlank: {
    type: Boolean,
    default: true
  }
})

const html = baseStringToHtml(props.string, props.forceTargetBlank)
</script>

<style module>
  .root {
  }

  .root h1,
  .root h2,
  .root h3,
  .root h4,
  .root h5,
  .root h6,
  .root h1 *,
  .root h2 *,
  .root h3 *,
  .root h4 *,
  .root h5 *,
  .root h6 {
    font-size: inherit;
    line-height: inherit;
    font-style: inherit;
    font-weight: normal;

    margin-bottom: var(--lh, 1em);
    margin-top: 0;

    padding-left: var(--unit--default);
    padding-right: var(--unit--default);
  }

  .root a {
    color: inherit;
    text-decoration-line: underline;
  }

  .root a:hover {
    text-decoration-line: none;
  }

  .root a * {
    text-decoration-line: none;
  }

  .root code {
    font-family: inherit;
  }

  .root ul,
  .root ol {
    padding: 0;
    margin: 0;
    margin-bottom: var(--lh, 1em);
    list-style-position: inside;
  }

  .root ol {
    list-style: none;
  }

  .root ol li,
  .root ul li {
    counter-increment: list-item;
    position: relative;
  }

  .root ol li {
    padding-left: var(--unit--default);
  }

  .root ul li {
    padding-left: var(--unit--default);
  }


  .root ol li::before {
    content: counter(list-item, decimal) ".\a0";
    position: absolute;
    top: 0;
    left: 0;
  }

  .root ul {
    list-style: none;
  }

  .root ul li::before {
    content: "–";
    position: absolute;
    top: 0;
    left: 0;
  }

  .root p {
    margin-bottom: var(--lh, 1em);
    margin-top: 0;
  }

  .root p:last-of-type {
    margin-bottom: 0;
  }

  .root p:empty {
    display: none;
  }

  .root em,
  .root i {
  }

  .root u {
  }

  .root b,
  .root strong {
  }

  .root sup,
  .root sub {
    line-height: 0;
    font-size: 75%;
  }

  .root blockquote {
    font-size: var(--font-medium--font-size);
    line-height: var(--font-medium--line-height);

    margin: 0;
    margin-bottom: calc(var(--unit--vertical) * 2);
  }

  .root blockquote * {
    text-underline-offset: var(--font-medium--text-underline-offset);
    text-decoration-thickness: var(--font-medium--text-decoration-thickness);
  }


  .root p + blockquote {
    margin-top: calc(var(--unit--vertical) * 1);
  }
</style>
